import {Button} from "antd";
import React, {ReactNode} from "react";
import Loading from "../../Loading/Loading";
import "./AppButton.scss";

interface IProps {
  key?: string
  className?: string;
  isFormSubmit?: boolean;
  type?: AppButtonType;
  loading?: boolean;
  disabled?: boolean;
  text: string | ReactNode;
  onClick: Function;
}

export enum AppButtonType {
  primary = 'primary',
  secondary = 'default',
  outline = 'ghost',
  link = 'link',
}

const AppButton = (props: IProps) => {

  const getClassName = (): string => {
    let className = getType().toString();
    if (props.className) className += ` ${props.className}`;
    return className;
  }

  const getType = (): AppButtonType => {
    return props.type ?? AppButtonType.primary;
  }

  return (
    <Button
      id="app-button"
      key={props.key}
      className={getClassName()}
      htmlType={props.isFormSubmit ? "submit" : "button"}
      type={getType()}
      disabled={props.disabled}
      onClick={() => props.onClick()}
    >
      {
        props.loading
          ? props.type === AppButtonType.link ? "Yükleniyor..." : <Loading/>
          : props.text
      }
    </Button>
  );
}

export default AppButton;
